"use client";

const Accreditation = ({ images }) => {
  return (
    <section className="py-12 max-w-screen-xl mx-auto px-10">
      <div className="mb-10">
        <h2 className="text-3xl font-bold text-slate-800 inline-block relative">
          Our Accreditations
          <span className="absolute bottom-8 left-0 w-full h-1 bg-red-600 transform -translate-y-2"></span>
        </h2>
        <p className="mt-4 text-slate-600 max-w-3xl">
          We're proud to be recognized by leading industry bodies, ensuring our
          training meets the highest standards.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {images.map((image, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center border border-slate-200">
            <img
              src={image || "/placeholder.svg"}
              alt={`Accreditation ${index + 1}`}
              className="max-h-[120px] object-contain"
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Accreditation;
